import { FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'

function NetworkInterfaceCard({ networkInterface }) {
  const { name, isUp, macAddress, mtu, addresses } = networkInterface

  return (
    <Box sx={{ p: 2, border: 1, borderColor: 'divider', borderRadius: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Typography variant="subtitle1" fontWeight="medium">
          {name}
        </Typography>
        <Chip
          size="small"
          label={<FormattedMessage id={isUp ? 'nodes.network.up' : 'nodes.network.down'} />}
          color={isUp ? 'success' : 'default'}
        />
      </Box>

      <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 1, mb: 2 }}>
        {macAddress && (
          <>
            <Typography variant="body2" color="text.secondary">
              <FormattedMessage id="nodes.network.macAddress" />
            </Typography>
            <Typography variant="body2" fontFamily="monospace">
              {macAddress}
            </Typography>
          </>
        )}
        {mtu && (
          <>
            <Typography variant="body2" color="text.secondary">
              <FormattedMessage id="nodes.network.mtu" />
            </Typography>
            <Typography variant="body2">
              {mtu}
            </Typography>
          </>
        )}
      </Box>

      {addresses.length > 0 && (
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            <FormattedMessage id="nodes.network.addresses" />
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            {addresses.map((addr) => (
              <Box key={addr.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Chip
                  size="small"
                  label={addr.addressType.toUpperCase()}
                  variant="outlined"
                  sx={{ minWidth: 50 }}
                />
                <Typography variant="body2" fontFamily="monospace">
                  {addr.address}{addr.prefixLength ? `/${addr.prefixLength}` : ''}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default NetworkInterfaceCard
